var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"IndexSISETA_div"}},[_c('menusuperior',{attrs:{"titulo":"SISETA","subtitulo":"Prestamo de tocas"}}),_vm._v(" "),_c('menuizquierda'),_vm._v(" "),_c('main',{staticClass:"content-area"},[_vm._t("title"),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d2063e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SISETA/Comun/Plantilla.vue
// module id = null
// module chunks = 